import MediaRepository from "./MediaRepository";
import API from "../services/api";
import Event from "../models/event/Event";

export default class EventRepository {
    static all = (all) => API.get('/event/all?all=' + (all ? 1 : 0)).then(response => response.data.events.map(event => Event.fromJson(event.event)));
    static get = (id) => API.get('/event/details/' + id).then(respone => Event.fromJson(respone.data.event));

    static create = (data) => API.post('/event/create', data);
    static update = (data) => API.post('/event/update', data).then(response => response.data);
    static quickUpdate = (data) => API.post('/event/quick-update', data).then(response => Event.fromJson(response.data.event));
    static updateContent = (data) => API.post('/event/content/update', data);
    static duplicate = (data) => API.post('/event/duplicate', data).then(response => Event.fromJson(response.data.event));
    static delete = (id) => API.delete('/event/delete?id=' + id);
    static toggle = (id) => API.post('/event/toggle', { id: id })
        .then(response => {
            if (API.isSuccess(response)) {
                return response.data.active;
            }
        });

    static getBackgroundVideos = (id, album) => {
        return new Promise((resolve, reject) => {
            MediaRepository.getAlbum(id, album, 'event')
                .then(response => {
                    let rows = [];

                    if (response.data?.media !== undefined) {
                        response.data.media.forEach(row => rows.push(row))
                    }
                    resolve(rows)
                })
                .catch(error => reject(error.message))
        })
    }
}
